if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        let option_set = document.querySelector("custom-switch")
        if(option_set) {
          this.form.addEventListener('submit', this.handleBundleSumit.bind(this));
        }
        else {
        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
  handleBundleSumit(evt) {
    if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();
    console.log("bundle")

    let option_set = document.querySelector("custom-switch")
      let sections = 'cart-icon-bubble';
      let objectsArray = [];
      let fetchRequestOpts;
      let formData;

    const form = event.target.closest("form");

        let check1 = false;
        let properties = {};

        // const idField = this.formData.filter(data => data.name === 'id');
        const id = parseInt(form.querySelector("input[name='product-id']").value);
        const quantity = parseInt(form.querySelector("input[name='quantity']").value);
        let main_pro = {
            'id': parseInt(document.querySelector("custom-switch").getAttribute("id")),
            'quantity': quantity,
            properties: properties
        }
        let check = false;
        let gangWrapper = document.querySelector(".first_step");

        let no_of_gang;
        if (gangWrapper) {
            no_of_gang = parseInt(gangWrapper.querySelector(".size_flex.active input:checked").dataset.gang);
            // console.log(no_of_gang , "test")
        }




let color_variants = document.querySelector(".color_switch_variant.active");
if (color_variants) {
    let selected_input = color_variants.querySelector("input:checked:not(:disabled)");
    if (selected_input) {
        // letTotalQUantitiy = document.querySelector('input[name="quantity"]').value;
        // console.log();
        let Modulequantity = parseInt(form.querySelector("input[name='quantity']").value);
        console.log('MODULE QTY:', Modulequantity);
        let selectedPlateItem = selected_input.getAttribute('data-id');

          objectsArray.push({
              'id': parseInt(selectedPlateItem),
              'quantity': Modulequantity
          })

        // ✅ new property (Bundle Price) FIRST
        let bundlePriceEl = document.querySelector("#bundle-price");
        if (bundlePriceEl) {
            properties[`Bundle Price`] = bundlePriceEl.value || "";
        }

        // ✅ new property (Your ID) — same way
        let yourIdEl = document.querySelector("#your-name");

        if (yourIdEl.value.trim() === "") {
          // First value
          yourIdEl.value = selectedPlateItem;
        } else {
          // Append new value with comma
          let currentValue = yourIdEl.value;
          yourIdEl.value = currentValue + "," + selectedPlateItem;
        }

        // Save into properties
        if (yourIdEl) {
          properties[`Link_id`] = yourIdEl.value || "";
        }

        // existing properties
        properties[`Step 1 - Select Plate Color`] = `${selected_input.closest(".item_col").dataset.prop}`;
        properties[`Step 2 - Select Plate Size`] = `${parseInt(no_of_gang) + 1} Gang`;

        check = true;

        let warning_text = color_variants.closest(".second_step").querySelector(".warning_text");
        if (warning_text) warning_text.remove();

    } else {
        check = false;
        let append_missing_value = `<p class="warning_text" style="color:red;font-size:12px;">Please Select plate color</p>`;
        let append_container = document.querySelector(".second_step");
        if (append_container) {
            if (!append_container.querySelector(".warning_text")) {
                append_container.insertAdjacentHTML("beforeend", append_missing_value);
            }
        }
    }
}




        let moduleWrapper = document.querySelector(".modules");
        if (moduleWrapper) {
            let module_items = moduleWrapper.querySelectorAll(".hide_module.active");
            if (module_items.length > 0) {
                module_items.forEach(function(module_item, index) {
                    let ind = parseInt(index) + 1
                    // console.log("module_item" , module_item)
                    let selected_input = module_item.querySelector("input:checked:not(:disabled)");
                    if (selected_input) {
                        // console.log("module_item", module_item, selected_input, "tt")
                        const Modulequantity = parseInt(form.querySelector("input[name='quantity']").value);
                        objectsArray.push({
                            'id': parseInt(selected_input.dataset.id),
                            'quantity': Modulequantity
                        })
                        properties[`Module ${ind} `] = `${selected_input.dataset.prop} / ${selected_input.dataset.sku}`
                        check = true;
                        let warning_text = module_item.querySelector(".warning_text");
                        if (warning_text) warning_text.remove()
                    } else {

                        let append_missing_value = `<p class="warning_text" style="color:red;font-size:12px;">Please Select Module ${ind}</p>`;
                        let append_container = module_item;
                        if (append_container) {
                            if (!module_item.querySelector(".warning_text")) {
                                append_container.insertAdjacentHTML("beforeend", append_missing_value);
                            }

                        }
                    }
                })
            }
        }
        let warning_text = document.querySelectorAll("custom-switch .warning_text");
        if (warning_text.length > 0) {
          this.submitBtn.setAttribute('aria-disabled', 'false');
      this.submitBtn.classList.remove('is-loading');
            return;
        }
        objectsArray.unshift(main_pro);
        formData = {
            items: objectsArray // This is the correct format for Shopify
        };
        
        if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }
        formData['sections_url'] = window.location.pathname;
        formData['sections']= sections;
        console.log(objectsArray)

   this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');
// console.log(formData);
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then(response => {
  if (!response.ok) {
    // Manually throw the error to be caught in `.catch()`
    this.submitBtn.setAttribute('aria-disabled', 'false');
      this.submitBtn.classList.remove('is-loading');
    
    return response.json().then(err => {
      throw new Error(err.message || 'Something went wrong');
    });
  }
  
  return response.json();
})
  .then(state => {
                        console.log("state", state)
                        const cart = document.querySelector('cart-drawer');
    this.submitBtn.setAttribute('aria-disabled', 'false');
      this.submitBtn.classList.remove('is-loading');
    
                        if (cart) {
                          console.log("staterrrrr", state)
          //                   const response = cart.getSectionsToRender().map((section) => section.section);
          // const cartResponse = await fetch(`?sections=${response.join(',')}`);
          // const sections = await cartResponse.json();
          // this.renderContents({ sections }, true);
                          //  let refreshHandler = cart.refresh.bind(this);
                          // document.addEventListener('dispatch:cart-drawer:refresh', refreshHandler);
                          cart.renderContents(state, true);
                          // cart.open();
                        } else {
                            // window.location = theme.routes.cart_url;
                        }


                    })
.catch((error) => {
  console.error('Error:', error);
});
        console.log("formData" , formData)
    
  }



    
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      let option_set = document.querySelector("custom-switch")
      let sections = 'cart-icon-bubble';
      let objectsArray = [];
      let fetchRequestOpts;
      let formData;
      
          formData = new FormData(this.form);
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }
        formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

       fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };
      
     

      
console.log(formData , 'tt' , sections)
      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}


if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        let option_set = document.querySelector("custom-switch");
        if (option_set) {
          this.form.addEventListener('submit', this.handleBundleSumit.bind(this));
        } else {
          if (theme.settings.afterAtc !== 'no-js') {
            this.form.addEventListener('submit', this.handleSubmit.bind(this));
          }
        }
      }
    }

    
    handleBundleSumit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();
      console.log("bundle");

      let option_set = document.querySelector("custom-switch");
      let sections = 'cart-icon-bubble';
      let objectsArray = [];
      let formData;

      const form = evt.target.closest("form");
      let properties = {};

      const id = parseInt(form.querySelector("input[name='product-id']").value);
      const quantity = parseInt(form.querySelector("input[name='quantity']").value);

      let gangWrapper = document.querySelector(".first_step");
      let no_of_gang;
      if (gangWrapper) {
        no_of_gang = parseInt(gangWrapper.querySelector(".size_flex.active input:checked").dataset.gang);
      }

      // Step 2: Color & Size
      let color_variants = document.querySelector(".color_switch_variant.active");
      let bundlePriceInput = document.querySelector("#bundle-price");
      if (color_variants) {
        let selected_input = color_variants.querySelector("input:checked:not(:disabled)");
        if (selected_input) {
          properties[`Bundle Price`] = bundlePriceInput.value || "0";
          properties[`Plate Color`] = `${selected_input.closest(".item_col").dataset.prop}`;
          properties[`Plate Size`] = `${parseInt(no_of_gang) + 1} Gang`;
          let warning_text = color_variants.closest(".second_step").querySelector(".warning_text");
          if (warning_text) warning_text.remove();
        } else {
          let append_missing_value = `<p class="warning_text" style="color:red;font-size:12px;">Please Select plate color</p>`;
          let append_container = document.querySelector(".second_step");
          if (append_container && !append_container.querySelector(".warning_text")) {
            append_container.insertAdjacentHTML("beforeend", append_missing_value);
          }
        }
      }

      // Step 3: Modules
      let moduleWrapper = document.querySelector(".modules");
      if (moduleWrapper) {
        let module_items = moduleWrapper.querySelectorAll(".hide_module.active");
        if (module_items.length > 0) {
          let MOdulequantity = parseInt(form.querySelector("input[name='quantity']").value);
          module_items.forEach(function(module_item, index) {
            let ind = parseInt(index) + 1;
            let selected_input = module_item.querySelector("input:checked:not(:disabled)");
            if (selected_input) {
              objectsArray.push({
                'id': parseInt(selected_input.dataset.id),
                'quantity': Modulequantity
              });
              properties[`Module ${ind}`] = `${selected_input.dataset.prop} / ${selected_input.dataset.sku}`;
              let warning_text = module_item.querySelector(".warning_text");
              if (warning_text) warning_text.remove();
            } else {
              let append_missing_value = `<p class="warning_text" style="color:red;font-size:12px;">Please Select Module ${ind}</p>`;
              if (!module_item.querySelector(".warning_text")) {
                module_item.insertAdjacentHTML("beforeend", append_missing_value);
              }
            }
          });
        }
      }


      let warning_text = document.querySelectorAll("custom-switch .warning_text");
      if (warning_text.length > 0) {
        this.submitBtn.setAttribute('aria-disabled', 'false');
        this.submitBtn.classList.remove('is-loading');
        return;
      }

      objectsArray.unshift(main_pro);

      formData = {
        items: objectsArray
      };

      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }
      formData['sections_url'] = window.location.pathname;
      formData['sections'] = sections;

      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => response.json())
        .then(state => {
          console.log("state", state);
          const cart = document.querySelector('cart-drawer');
          this.submitBtn.setAttribute('aria-disabled', 'false');
          this.submitBtn.classList.remove('is-loading');

          if (cart) {
            cart.renderContents(state, true);
          } else {
            window.location = theme.routes.cart_url;
          }
        })

        .catch((error) => {
          console.error('Error:', error);
          this.submitBtn.setAttribute('aria-disabled', 'false');
          this.submitBtn.classList.remove('is-loading');
        });
    }

    // keep your handleSubmit & other methods unchanged
  }
  customElements.define('product-form', ProductForm);
}